import { Layer } from 'effect';
import * as Atom from 'effect/unstable/reactivity/Atom';

import { CoreEngineLayerClient } from '@vs-shop/engine/runtime/layers/ClientLayer';

import { CategoryListingLive } from '../../capability/CategoryListingLive';
import { ProductCatalogueLive } from '../../capability/ProductCatalogueLive';
import { ProductListingLive } from '../../capability/ProductListingLive';
import { CartLive } from '../../capability/cart/CartLive';
import { CustomerAccountLive } from '../../capability/customerAccount/CustomerAccountLive';

/**
 * RCProfi's browser runtime combines the engine layer with the listing and cart services.
 *
 * The listing services are here because rcprofi pages products in the browser, and a port that
 * only ever composed over the server's HTTP client would be a port proven on
 * one side of the boundary. The same provider value serves both sides: the
 * layer closes over whatever runtime context it is given, so the browser's
 * `FetchHttpClient` and the server's client are equally its own.
 *
 * `CatalogueMenu` and `ProductDetail` are absent because no browser read asks for them.
 * The menu and product page render on the server.
 * The cart command uses `CartLive` in this browser runtime.
 */
export const ClientLayer = Layer.mergeAll(
  CategoryListingLive,
  ProductCatalogueLive,
  ProductListingLive,
  CartLive,
  CustomerAccountLive
).pipe(Layer.provideMerge(CoreEngineLayerClient));

export const CartClientAtom = Atom.runtime(ClientLayer);
export const AccountClientAtom = CartClientAtom;

export type ClientLayer = typeof ClientLayer;
